import React from "react";
import { ButtonProps } from "./Button.types";
import { ButtonContainer } from "./Button.style";

export default function Button({
  text,
  type,
  fontColor,
  backgroundColor,
  click,
  id,
  disabled,
  className,
  children,
}: ButtonProps) {
  return (
    <ButtonContainer
      className={className}
      $type={type}
      disabled={disabled}
      $fontColor={fontColor}
      $backgroundColor={backgroundColor}
      id={id}
      onClick={click}
    >
      {children || (text && <span className="p-small">{text}</span>)}
    </ButtonContainer>
  );
}
